import { Link } from "react-router-dom";
import { Phone, MapPin, Banknote, Heart } from "lucide-react";
import { useSettings } from "@/lib/settings";
import { useContent } from "@/lib/content";

export default function Footer() {
  const settings = useSettings();
  const { t } = useContent();
  return (
    <footer id="contact" data-testid="footer" className="bg-teal-deep text-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <img data-testid="footer-logo" src="/logo-light.png" alt={settings.shop_name} className="h-20 md:h-24 w-auto" />
            <p className="mt-4 text-cream/70 max-w-sm">{settings.tagline} — {settings.address}.</p>
            <div className="mt-8 flex items-center gap-3 rounded-2xl bg-teal/60 border border-cream/10 px-5 py-4 max-w-sm">
              <Banknote size={22} className="text-mint shrink-0" />
              <p className="text-sm text-cream/90">
                {t("footer.payment")}
              </p>
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow !text-mint">{t("footer.col_shop")}</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link data-testid="footer-link-home" to="/" className="link-underline text-cream/85 hover:text-mint transition-colors">{t("footer.link_home")}</Link></li>
              <li><Link data-testid="footer-link-catalog" to="/boutique" className="link-underline text-cream/85 hover:text-mint transition-colors">{t("footer.link_shop")}</Link></li>
              <li><Link data-testid="footer-link-services" to="/accompagnement" className="link-underline text-cream/85 hover:text-mint transition-colors">{t("footer.link_services")}</Link></li>
              <li><Link data-testid="footer-link-blog" to="/conseils" className="link-underline text-cream/85 hover:text-mint transition-colors">{t("footer.link_blog")}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow !text-mint">{t("footer.col_contact")}</p>
            <ul className="mt-4 space-y-3 text-sm text-cream/85">
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-mint shrink-0" />
                <a data-testid="footer-phone" href={`https://wa.me/${(settings.whatsapp || settings.phone || "").replace(/\D/g, "")}`} target="_blank" rel="noopener noreferrer">{settings.phone} <span className="text-cream/60">{t("footer.phone_note")}</span></a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={16} className="text-mint shrink-0" />
                {settings.address}
              </li>
              <li className="flex items-center gap-3">
                <Heart size={16} className="text-rose shrink-0" />
                {t("footer.delivery")}
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-cream/50">
          <p>{t("footer.copyright", { annee: String(new Date().getFullYear()) })}</p>
        </div>
      </div>
    </footer>
  );
}
